import React from 'react';
import { Button, Card, Empty, Space, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function EntityCommentsCard({
  entityId,
  entityName,
  getLatestComment,
  formatDateTime,
  onOpenComments,
  title = 'Comments',
}) {
  const latestComment = getLatestComment(entityId);

  return (
    <Card
      size="small"
      title={(
        <Space>
          <CommentOutlined />
          <span>{title}</span>
        </Space>
      )}
    >
      {latestComment ? (
        <>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {formatDateTime(latestComment.timestamp)} - {latestComment.author}
          </Text>
          <div style={{ marginTop: '8px', marginBottom: '12px' }}>
            <Text>{latestComment.comment}</Text>
          </div>
          <Button type="link" size="small" onClick={() => onOpenComments(entityId, entityName)}>
            View More
          </Button>
        </>
      ) : (
        <>
          <Empty
            description="No comments yet"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ margin: '8px 0' }}
          />
          <Button type="link" size="small" onClick={() => onOpenComments(entityId, entityName)}>
            Add Comment
          </Button>
        </>
      )}
    </Card>
  );
}
